module.exports = __webpack_public_path__ + "img/hk.76aa7532.svg";